export const WebLinkConfig = {
  getAll: '/weblink/v1/dataflow/{:dataflowId}',
  create: '/weblink/v1/dataflow/{:dataflowId}',
  delete: '/weblink/v1/{:webLinkId}/dataflow/{:dataflowId}',
  update: '/weblink/v1/dataflow/{:dataflowId}'
};
